<script setup>
const props = defineProps({
  overtimes: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['delete', 'show']);

function show(id) {
  emit('show', id);
}

function formatTime(datetime) {
  return dayjs(datetime).format('HH:mm');
}

function formatDate(datetime) {
  return dayjs(datetime).format('DD');
}
</script>

<template>
  <table
    v-if="overtimes.length"
    class="w-full overflow-auto border-separate table-auto"
  >
    <thead>
      <tr>
        <th>date</th>
        <th>begin</th>
        <th>end</th>
        <th>type</th>
        <th>status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <template v-for="overtime in overtimes">
        <tr class="text-center hover:bg-gray-200">
          <td>
            <div class="text-white bg-indigo-400 rounded-full">
              {{ formatDate(overtime.begin_time) }}
            </div>
          </td>
          <td>{{ formatTime(overtime.begin_time) }}</td>
          <td>{{ formatTime(overtime.end_time) }}</td>
          <td>{{ overtime.ot_type }}</td>
          <td>
            {{
              overtime.status === 'approved' ? '✅' : '⏳'
            }}
          </td>
          <td><button @click="show(overtime.id)">🔍</button></td>
        </tr>
      </template>
    </tbody>
  </table>
  <div v-else class="text-center">no data, please try other conditions</div>
</template>
